import React from "react";

import CSSModules from "lib/utils/css-modules";
import * as FormControl from "lib/components/FormControl";

import styles from "./CategoryFacilitiesFormSection.less";

@CSSModules(styles)
export default class CategoryFacilitiesFormSection extends React.PureComponent {
  render() {
    const {
      facility_product_variants,
      errors,
      productVariantFormSectionName,
      onBlur,
      title,
      categoryFacilities,
      readOnlyAccess,
      onFacilityChange,
    } = this.props;
    const checkedFacilityIds = new Set((facility_product_variants || []).map(({ facility_id }) => facility_id));

    return (
      <div styleName="category-facilities">
        <h4>{title}</h4>
        {categoryFacilities.map(({ id, name }) => (
          <FormControl.CheckboxFormGroup
            {...FormControl.addProps(`${productVariantFormSectionName}.facility_product_variants[${id}]`, { errors })}
            key={`facility_${id}`}
            value={checkedFacilityIds.has(id)}
            onBlur={onBlur}
            onChange={(checked) => onFacilityChange(id, checked)}
            label={name}
            toggle
            readOnly={readOnlyAccess}
          />
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepAccommodationSettings/CategoryFacilitiesFormSection.jsx